import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const userData = {
  'name': 'username'
}

const routes = [
  {
    path: '/',
    redirect: 'login',
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue')
      },
      {
        path: '/template-kosong',
        name: 'template kosong',
        component: () => import(/* webpackChunkName: "demo" */ '../views/TemplateKosong.vue')
      },
      {
        path: '/selenggaraPengguna',
        name: 'selenggaraPengguna',
        component: () => import(/* webpackChunkName: "demo" */ '../views/selenggaraPengguna/senaraipengguna.vue')
      },
      {
        path: '/setMaklumatPeribadi',
        name: 'MAKLUMAT PERIBADI',
        component: () => import(/* webpackChunkName: "demo" */ '../views/kalkulatorGaji/setMaklumatPeribadi.vue')
      },
      {
        path: '/editMaklumatPeribadi',
        name: 'KEMASKINI MAKLUMAT PERIBADI',
        component: () => import(/* webpackChunkName: "demo" */ '../views/kalkulatorGaji/EditMaklumatPeribadi.vue')
      },
      {
        path: '/statusMaklumatLantikan',
        name: 'STATUS MAKLUMAT PEGAWAI LANTIKAN SEBELUM 2003',
        component: () => import(/* webpackChunkName: "demo" */ '../views/kalkulatorGaji/setMaklumatPegSeb2003.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/statusAnjakanGaji',
        name: 'STATUS ANJAKAN GAJI',
        component: () => import(/* webpackChunkName: "demo" */ '../views/kalkulatorGaji/setAnjakanGaji.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/statusKenaikanPangkat',
        name: 'STATUS KENAIKAN PANGKAT',
        component: () => import(/* webpackChunkName: "demo" */ '../views/kalkulatorGaji/setKenaikanPangkat.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/statusGajiKup',
        name: 'STATUS GAJI KUP BERMULA 2015',
        component: () => import(/* webpackChunkName: "demo" */ '../views/kalkulatorGaji/setGajiKup.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/statusPenetapanGaji',
        name: 'STATUS PENETAPAN GAJI PERMULAAN',
        component: () => import(/* webpackChunkName: "demo" */ '../views/kalkulatorGaji/setPenetapanGaji.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/statusTukarLantik',
        name: 'STATUS TUKAR LANTIK PP01/2016',
        component: () => import(/* webpackChunkName: "demo" */ '../views/kalkulatorGaji/setTukarLantik.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/statusMaklumatPerGaji',
        name: 'STATUS TIADA PERGERAKAN GAJI TAHUNAN',
        component: () => import(/* webpackChunkName: "demo" */ '../views/kalkulatorGaji/setMaklumatPegGaji.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/paparMaklumat',
        name: 'MAKLUMAT KIRA GAJI',
        component: () => import(/* webpackChunkName: "demo" */ '../views/kalkulatorGaji/paparMaklumat.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      //FOLDER SKG
      {
        path: '/setMaklPer',
        name: 'MAKLUMAT PENJAWAT AWAM',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Skg/SetMaklPeribadi.vue')
      },
      {
        path: '/detMaklPer',
        name: 'BUTIRAN MAKLUMAT PERIBADI',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Skg/DetailMaklPeribadi.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/dashboardSkg',
        name: 'DASHBOARD KIRAAN GAJI',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Skg/DashboardSkg.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/selMaklGaji',
        name: 'BUTIRAN MAKLUMAT GAJI',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Skg/SelesaiMaklGaji.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/DaftarPegawai',
        name: 'DAFTAR PEGAWAI',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Skg/Pentadbir_BGE/daftar_kiraan.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/DashboardPentadbirBGE',
        name: 'DASHBOARD PENTADBIR BGE',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Skg/Pentadbir_BGE/dashboard.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/KemaskiniMaklPemohon',
        name: 'KEMASKINI MAKLUMAT PEMOHON',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Skg/Pentadbir_BGE/KemaskiniMaklPemohon.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/KemaskiniMaklPemohonFasi',
        name: 'KEMASKINI MAKLUMAT PEMOHON FASI',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Skg/Fasi_BGE/KemaskiniMaklPemohonFasi.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/DashboardFasiBGE',
        name: 'DASHBOARD FASI BGE',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Skg/Fasi_BGE/dashboardFasi.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/DashboardPSMBGE',
        name: 'DASHBOARD PSM BGE',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Skg/PSM_BGE/dashboardPSMBGE.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },
      {
        path: '/DaftarKiraanPSM',
        name: 'DAFTAR KIRAAN PSM',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Skg/PSM/daftar_kiraanPSM.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },


      //template
      {
        path: '/tempelem1',
        name: 'GAJI LANTIKAN PERTAMA',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Skg/tempGajiLantikanPertama.vue'),
        props: (route) => ({
          user: userData,
          ...route.params
        })
      },



      {
        path: '/visit-table',
        name: 'visit table',
        component: () => import(/* webpackChunkName: "demo" */ '../views/PageVisitsTable.vue')
      },
      {
        path: '/social-ttraffic',
        name: 'Social Trafik',
        component: () => import(/* webpackChunkName: "demo" */ '../views/SocialTrafficTable.vue')
      },
      {
        path: '/icons',
        name: 'icons',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Icons.vue')
      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserProfile.vue')
      },
      {
        path: '/maps',
        name: 'maps',
        component: () => import(/* webpackChunkName: "demo" */ '../views/GoogleMaps.vue')
      },
      {
        path: '/tables',
        name: 'tables',
        component: () => import(/* webpackChunkName: "demo" */ '../views/RegularTables.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Register.vue')
      },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
